module.exports = __webpack_public_path__ + "img/fileClose.fcd7ac57.png";